<template>
    <pre class="Debug" v-html="debugObject" />
</template>

<script setup>
import { computed } from "vue";

const props = defineProps(['data']);

const debugObject = computed( () =>
{
    let json = typeof props.data === 'string' ? props.data : JSON.stringify( props.data, undefined, 2 );

    json = json.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');

    return json.replace( new RegExp('("(\\u[a-zA-Z0-9]{4}|\\[^u]|[^\\"])*"(\s*:)?|\b(true|false|null)\b|-?\d+(?:\.\d*)?(?:[eE][+\-]?\d+)?)','g'), (match) =>
    {
        let cls = 'number';

        if (new RegExp('^"').test(match))
        {
            if (/:$/.test(match)){ cls = 'key'; } else { cls = 'string'; }
        }
        else if (/true|false/.test(match))
        {
            cls = 'boolean';
        }
        else if (/null/.test(match))
        {
            cls = 'null';
        }
        return '<span class="' + cls + '">' + match + '</span>';
    });
})
</script>

<style lang="scss">
pre.Debug
{
    color: #333;
    user-select: text;
    -webkit-user-select: text;
    -moz-user-select: text;

    .number  { color: #008080; }
    .key     { color: #333; }
    .string  { color: #d14; }
    .boolean { color: #008080; }
    .null    { color: #008080; }
}
</style>